import styled from "styled-components";
import { ThemeType } from "../../../types/Theme";

export const LoadingCarrinhoContainer = styled.div<{
  theme: ThemeType;
  position: "absolute" | "fixed";
}>`
  > .componente-carregando-pagina {
    position: ${({ position }) => position};
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 3rem;
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) => theme.colors.modal};
    z-index: 200;

    .carrinho-container {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100px;
      height: 100px;
    }

    .mensagem {
      font-weight: bold;
      color: ${({ theme }) => theme.colors.secondary};
    }

    .sub-mensagem {
      color: ${({ theme }) => theme.colors.secondary};
    }
  }
`;
